<template>
<div class="page_success">
    <div class="top">
        <img :src="this.publicPath+'statics/images/shop/recive.png'" alt="" class="tu">
    </div>
    <div class="tips">
        <div class="txt" v-if="type == 'made'">{{ dingzhi_status == 1 ? '预付成功, 等待定制' : dingzhi_status == 2 ? '尾款支付成功, 等待收货' : '支付成功, 等待收货' }}</div>
		<div class="txt" v-if="type != 'made'">支付成功</div>
		<div class="sub_txt">每天都给自己一点惊喜吧</div>
    </div>
    <div class="actions">
        <div class="action action01" @click="goIndex">再去逛逛</div>
        <div class="action action02" @click="goOrderDetail">查看订单</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            from: this.$route.query.from, // 来源
			orderId: this.$route.query.orderId, // 订单id
			type: this.$route.query.type, // 定制 type = made  视频 type = video 约看type=yuekan
			dingzhi_status: this.$route.query.dingzhi_status // 1 待付定金, 2 待付尾款
        };
    },
    components: {
        // PageSearch
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '支付成功'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        }
        // 获取列表
        this.getData();
        // console.log(this.$refs.marker)
    },
	beforeRouteLeave (to, from, next) {
		// console.log('to===',to);
		if(to.name == "shop-order"){
			to.meta.isrefer = true;
		};
		next();
	},
    methods: {
        // 获取列表
        getData() {
            var token = this.$store.getters.token;
            var param = {};
        },
        // 再逛逛 进首页
        goIndex() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://public/popToRoot', params, (data) => {

                })
            } else {
                if (this.from == 'number') {
                    window.open(this.$publicData.numberUrl) 
                } else {
                    this.$router.push({
                        name: 'home'
                    })
                }
            }
		},
		// 查看订单详情
		goOrderDetail(){
            if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
				var url = this.type == 'made' ? this.$publicData.clientUrl+'/order/dingzhi/index?status=2' : this.$publicData.clientUrl+'/shop/order?status=2'
                var params = {'data':{'url': url}}
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
				if(this.type == 'made'){
					if(this.dingzhi_status == 1){
                        if (this.from == 'number') {
                            var url = this.$publicData.numberUrl+'/order/dingzhi/index?status=2'
                            window.open(url) 
                        } else {
                            this.$router.push({
                                path: '/order/dingzhi/index',
                                query:{
                                    status: 2
                                }
                            })	
                        }
						
					} else if(this.dingzhi_status == 2){
                        if (this.from == 'number') {
                            var url = this.$publicData.numberUrl+'/order/dingzhi/index?status=4'
                            window.open(url) 
                        } else {
                            this.$router.push({
                                path: '/order/dingzhi/index',
                                query:{
                                    status: 4
                                }
                            })
                        }
					}
					
				}else if(this.type == 'video'){
					if (this.from == 'number') {
						var url = this.$publicData.numberUrl+'/video/index'
						window.open(url) 
					} else {
						this.$router.push({
							path: '/video/index',
						})
					}
				}else if(this.type == 'yuekan'){
					if (this.from == 'number') {
						var url = this.$publicData.numberUrl+'/yuekan/order/index'
						window.open(url) 
					} else {
						this.$router.push({
							path: '/yuekan/order/index',
						})
					}
				}else{
                    if (this.from == 'number') {
                        var url = this.$publicData.numberUrl+'/shop/order?status=2'
                        window.open(url) 
                    } else {
                        this.$router.push({
                            path: '/shop/order',
                            query:{
                                status: 2
                            }
                        })
                    }
				}
                
            }
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
